import { BottomOverlayMenuButton } from 'features/siteView'
import { PlusIcon } from 'lucide-react'
import { useFeatureInteractionContext } from 'pages/siteView/siteMap/contexts/FeatureInteractionContext'
import React, { FC, MouseEvent } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'

const StyledPlusIcon = styled(PlusIcon)`
  width: 32px;
  height: 32px;
  margin-left: -4px;
`

interface AddFeatureButtonProps {
  closeMenu: () => void
}

export const AddFeatureButton: FC<AddFeatureButtonProps> = (props) => {
  const { setShowFeaturePopupMenu, setSelectedFeature } =
    useFeatureInteractionContext()
  return (
    <BottomOverlayMenuButton
      onClick={(e: MouseEvent) => {
        props.closeMenu()
        setSelectedFeature(undefined)
        setShowFeaturePopupMenu(new Vector2(e.clientX, e.clientY))
      }}>
      <StyledPlusIcon />
      Add Feature
    </BottomOverlayMenuButton>
  )
}
